import "./ForgotPassword.scss";
import { useEffect, useRef, useState } from "react";
import { MailOutlined } from "@ant-design/icons";
import { Card, Form } from "antd";
import { Link, useNavigate } from "react-router-dom";
import useAuth from "../../hooks/useAuth";
import { useTranslation } from "react-i18next";
import { validateEmail } from "../../utils/utils";
import { FormInstance } from "antd/lib";
import api from "../../hooks/api";
import { pathAPI } from "../../utils/pathApi";
import { Box, InputAdornment } from "@mui/material";
import LightScope from "../../theme/LightScope";
import ActionButton from "../../components/common/buttons/ActionButton";
import InputField from "../../components/common/fields/InputField";

const ForgotPassword = () => {
  const { isLogin } = useAuth();
  const navigate = useNavigate();
  const formRef = useRef<FormInstance>(null);
  const { i18n, t } = useTranslation();
  const [message, setMessage] = useState("");
  const [loading, setLoading] = useState(false);
  useEffect(() => {
    var currentLang: any = localStorage.getItem("language");
    i18n.language = currentLang;
    if (isLogin) navigate("/", { replace: true });
  }, []);

  const onFinish = (values: any) => {
    if (!values.email) {
      formRef?.current?.setFields([
        {
          name: "email",
          errors: [t("auth.email_required")],
        },
      ]);
      return;
    }
    if (validateEmail(values.email || "")) {
      setLoading(true);
      api
        .POST(pathAPI.forgetPasswordRequset, values, {}, true)
        .then((res) => {
          setMessage(res.data ? res.data?.content || "" : "");
        })
        .catch((err: Error) => {
          let res: string = `${err.message}`;
          console.log(JSON.parse(res).message);
        })
        .finally(() => {
          setLoading(false);
        });
    } else {
      formRef?.current?.setFields([
        {
          name: "email",
          errors: [t("auth.email_invalid")],
        },
      ]);
    }
  };

  return (
    <LightScope>
    <div className="forgot-password">
      <div className="sub-login">
        <Card
          title={t("screen_title.forgot_password")}
          headStyle={{
            background: "#ba2156",
            color: "white",
            textAlign: "center",
          }}
        >
          {message && (
            <Box mb={2} fontSize={16} textAlign={"center"}>
              Password reset link sent to your email.
            </Box>
          )}
          {!message && (
            <Form
              ref={formRef}
              name="normal_login"
              className="login-form"
              initialValues={{ remember: true }}
              onFinish={onFinish}
            >
              <Form.Item
                name="email"
                rules={[
                  { required: true, message: `${t("mess.input_email")}` },
                ]}
              >
                <InputField
                  startAdornment={
                    <InputAdornment position="start">
                      <MailOutlined className="site-form-item-icon" />
                    </InputAdornment>
                  }
                  placeholder={t("auth.email_ph")}
                />
              </Form.Item>

              <Form.Item>
                <ActionButton appSize="large" type="submit" loading={loading} sx={{ width: "50%" }}>
                  {t("btn.send_email")}
                </ActionButton>
              </Form.Item>
            </Form>
          )}
          <Link className="login-form-forgot" to="/login">
            {t("btn.sign_in")}
          </Link>
        </Card>
      </div>
    </div>
    </LightScope>
  );
};
export default ForgotPassword;
